
    import Vue from 'vue';
    import vuex from '../../store';
    import moment from 'moment';
    // Store
    import { DownloadIcon , MoreVerticalIcon} from 'vue-feather-icons';
    import UnitPlan from "@/store/units/UnitPlan";
    import UnitPlanAttitude from '@/store/planner/purpose/UnitPlanAttitude';
    import UnitPlanPreLearning from '@/store/planner/purpose/UnitPlanPreLearning';
    import UnitPlanSkill from '@/store/planner/purpose/UnitPlanSkill';
    import UnitPlanComments from '@/store/units/UnitPlanComments';

    import RomaUnitModalForm from './RomaUnitModalForm.vue';
    import RomaConfirmDialog from '../commons/RomaConfirmDialog.vue';

    export default Vue.extend({
        name: 'RomaAnualPlanPanel',
        mounted() {
        },
        props: {
            anualPlan: {
                type: Object,
                required: true
            },
            school: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: null,
                canGenerateAnualCoverageReport: this.$store.state.user.privileges.canSeeReportAnual,
                userId: this.$store.state.user.userId,
                userPrivileges: this.$store.state.user.privileges,
                isUTP: this.$store.state.user.isUTP,
                isAdministradorAcademico: this.$store.state.user.roles.includes('AdministradorAcademico'),
                unitPlansList: [],
                modalTittle: '',
                modalAction: '',
                selectedUnit: null,
                showUnitModalForm: false,
                dialogDeleteUnit: false,
                dialogActivateUnit: false,
                unsubscribe: null,
                planUnitsByState: true,
                isDeleting: false,
            }
        },
        created(){
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if(mutation.type=="setRoma"){
                    this.getUnitPlansByPage();
                }else{
                    this.unitPlansList = UnitPlan.query()
                        .orderBy('asignatura')
                        .orderBy('educationLevel')
                        .orderBy('level')
                        .orderBy('course')
                        .orderBy('name1')
                        .withAll()
                        .where('id_plan', this.anualPlan.id_plan_anual)
                        .get();
                }
            })
        },
        beforeDestroy(){
            this.unsubscribe();
        },
        computed: {

        },
        watch: {
            planUnitsByState: function (val) {
                this.getUnitPlansByPage();
            }
        },
        methods: {
            navigate(unitPlan: any){
                this.$router.push()
            },
            textCapitalize(value: string){
                let aux = value.trim().split(' ');
                aux = aux.filter( element => element != '');
                aux = aux.map( (word: string, index: number) => {
                    word = word.trim();
                    if(index == 0){
                        return word[0].toUpperCase() + word.slice(1).toLowerCase();
                    }else{
                        return word.toLowerCase();
                    }
                })
                return aux.join(' ');
            },
            twoDecimalsFixed(value: number){
                return value.toFixed(2);
            },
            dayMonthFormat(value){
                return moment(value, 'YYYY-MM-DD').locale('es').format('DD/MM')
            },
            clickPanel(){
                if(this.loading == null){
                    this.getUnitPlansByPage();
                }
            },
            goDelUnit(unitPlan: any) {
                this.dialogDeleteUnit = true;
                this.selectedUnit = unitPlan;
            },
            goActivateUnit(unitPlan: any) {
                this.dialogActivateUnit = true;
                this.selectedUnit = unitPlan;
            },
            async activateUnit() {
                this.loading = true;
                let msj = {
                    show: true,
                    text: '',
                    color: 'success',
                };
                const response = await this.$store.dispatch('activatePlanUnit', this.selectedUnit.id);

                if (response.data && response.data.status && response.data.status.code === 1) {
                    msj.text = 'Se ha activado el plan unidad';
                    await this.$store.dispatch('roma', {});
                } else if (response.data && response.data.status && response.data.status.code === 3) {
                    msj.text = response.data.content.message;
                    msj.color = 'red';
                } else {
                    msj.text = 'Planificación no pudo ser activada';
                    msj.color = 'red';
                }
                this.dialogActivateUnit = false;
                await this.getUnitPlansByPage();
                this.loading = false;
                this.$store.state.snackbar = msj;
                this.$emit("refresh-activities", true);
            },
            async delUnit() {
                this.loading = true;
                let msj = {
                    show: true,
                    text: '',
                    color: 'success',
                };
                const response = await this.$store.dispatch('deletePlanUnit', this.selectedUnit.id);

                if (response.data && response.data.status && response.data.status.code === 1) {
                    msj.text = 'Se ha borrado el plan unidad';
                    await this.$store.dispatch('roma', {});
                    UnitPlan.delete(this.selectedUnit.id);
                    UnitPlanAttitude.delete((detail: IUnitPlanAttitude) => detail.unitplan_id === this.selectedUnit.id); // Actitudes
                    UnitPlanPreLearning.delete((detail: IUnitPlanPreLearning) => detail.unitplan_id === this.selectedUnit.id);
                    UnitPlanSkill.delete((detail: IUnitPlanSkill) => detail.unitplan_id === this.selectedUnit.id);
                } else if (response.data && response.data.status && response.data.status.code === 3) {
                    msj.text = response.data.content.message;
                    msj.color = 'red';
                } else {
                    msj.text = 'Planificación no pudo ser borrada';
                    msj.color = 'red';
                }
                this.dialogDeleteUnit = false; 
                await this.getUnitPlansByPage();
                this.loading = false;
                this.$store.state.snackbar = msj;
                this.$emit("refresh-activities", true);
            },
            async setStatus(unit: any, commands: any) {
                this.loading = true;
                const msj = {
                    show: true,
                    text: '',
                    color: 'success',
                };
                const request = {
                    idPlanUnidad: unit.id,
                    commands,
                };
                await this.$store.dispatch('setUnitPlanStatus', request)
                    .then(async (response) => {
                        if (response.data && response.data.status && response.data.status.code === 1) {
                            msj.text = response.data.content;
                            await this.getUnitPlansByPage();
                        } else if (response.data && response.data.status && response.data.status.code === 3) {
                            msj.text = response.data.content.message;
                            msj.color = 'red';
                        } else {
                            msj.text = 'No se pudo cerrar la edición';
                            msj.show = false;
                        }
                        this.$store.state.snackbar = msj;
                        return;
                    })
                    .catch((error) => {
                        this.$store.state.snackbar = msj;
                    });
                this.loading = false;
            },
            duplicateUnit(unitPlan: any) {
                this.modalTittle = 'Duplicar Plan Unidad';
                this.modalAction = 'Duplicate';
                unitPlan.yearFilter= this.$store.state.unitList.paginator.filter.years;
                this.selectedUnit = unitPlan;
                this.showUnitModalForm = true;
            },
            editUnit(unitPlan: any) {
                this.modalTittle = 'Editar Plan Unidad';
                this.modalAction = 'Edit';
                unitPlan.yearFilter= this.$store.state.unitList.paginator.filter.years;
                this.selectedUnit = unitPlan;
                this.showUnitModalForm = true;
            },
            async getUnitPlansByPage() {
                this.loading = true;
                const filter = this.$store.state.unitList.paginator.filter;
                const params = `idInstitucion=${filter.institution}&idPlanAnual=${this.anualPlan.id_plan_anual}&idAsignatura=-1&idCategoria=-1&courseName=null&idUnidad=-1&idEstadoEdicion=-1&idEstadoPlan=-1&idPersona=-1&porcentajeAvanceCurricular=-1&page=1&itemsPerPage=10&isActive=${this.planUnitsByState}&pie=false&puName=&year=-1`;
                const request = new URLSearchParams(params);
                return await vuex.dispatch('getUnitPlans', request).then(data => {

                    let unitPlansToDelete = UnitPlan.query()
                        .orderBy('asignatura')
                        .orderBy('educationLevel')
                        .orderBy('level')
                        .orderBy('course')
                        .orderBy('name1')
                        .withAll()
                        .where('id_plan', this.anualPlan.id_plan_anual)
                        .get();

                    unitPlansToDelete.forEach( unitPlan => {
                        UnitPlan.delete(unitPlan.id);
                        UnitPlanAttitude.delete((detail: IUnitPlanAttitude) => detail.unitplan_id === unitPlan.id); // Actitudes
                        UnitPlanPreLearning.delete((detail: IUnitPlanPreLearning) => detail.unitplan_id === unitPlan.id);
                        UnitPlanSkill.delete((detail: IUnitPlanSkill) => detail.unitplan_id === unitPlan.id);
                    });

                    if (data.data.content.data.length > 0) {
                        data.data.content.data.forEach(uniplan => {
                            // Educación para poder ordenar por educación media y básica
                            uniplan.educationLevel = uniplan.nivel.substring(uniplan.nivel.lastIndexOf('°') + 1).trim();
                            // Campos de nivel y sección por separado
                            uniplan.level = uniplan.nivel;
                            uniplan.course = uniplan.seccion;
                            uniplan.levelAb = uniplan.cat_abreviatura;
                            UnitPlan.insertOrUpdate({data: uniplan});

                        });
                    }
                    this.unitPlansList = UnitPlan.query()
                        .orderBy('asignatura')
                        .orderBy('educationLevel')
                        .orderBy('level')
                        .orderBy('course')
                        .orderBy('name1')
                        .withAll()
                        .where('id_plan', this.anualPlan.id_plan_anual)
                        .get();
                    this.loading = false;
                }).catch(errors => {
                    //console.log(errors);
                });
            },
            generateUnitPlanReport(unitPlan: any) {
                const bodyEvent = {
                    reportType: 1,
                    data: unitPlan
                }
                this.$emit('generate-report', bodyEvent);
            },
            generateAnualPlanReport(anualPlan: any){
                const bodyEvent = {
                    reportType: 2,
                    data: anualPlan
                }
                this.$emit('generate-report', bodyEvent);
            },
            generateAnualCoverageReport(anualPlan: any){
                const bodyEvent = {
                    reportType: 3,
                    data: anualPlan
                }
                this.$emit('generate-report', bodyEvent);
            }
        },
        components: {
            RomaUnitModalForm,
            RomaConfirmDialog,
            DownloadIcon,
            MoreVerticalIcon
        }
    })
